// export const webMenu = [
//   {
//     id: 2,
//     name: 'Gold',
//     hasSubMenu: true,
//     mainCategory: 'gold',
//     subMenus: [
//       {
//         subCategory: 'Earrings',
//         productStyleMenus: [
//           {
//             name: 'Studs',
//           },
//           {
//             name: 'Hangings',
//           },
//           {
//             name: 'Drops',
//           },
//         ],
//       },
//       {
//         subCategory: 'Necklace',
//         productStyleMenus: [
//           {
//             name: 'Short necklace',
//             link: '/',
//           },
//           {
//             name: 'Long necklace',
//             link: '/',
//           },
//         ],
//       },
//       {
//         subCategory: 'Rings',
//         productStyleMenus: [
//           {
//             name: 'Band rings',
//             link: '/',
//           },
//           {
//             name: 'Engagement rings',
//             link: '/',
//           },
//           {
//             name: 'Casual rings',
//             link: '/',
//           },
//         ],
//       },
//     ],
//     link: '',
//   },
//   {
//     id: 3,
//     name: 'Diamond',
//     hasSubMenu: true,
//     mainCategory: 'diamond',
//     subMenus: [
//       {
//         subCategory: 'Earrings',
//         productStyleMenus: [
//           {
//             name: 'Studs',
//           },
//           {
//             name: 'Hangings',
//           },
//           {
//             name: 'Drops',
//           },
//         ],
//       },
//       {
//         subCategory: 'Necklace',
//         productStyleMenus: [
//           {
//             name: 'Short necklace',
//           },
//           {
//             name: 'Long necklace',
//           },
//         ],
//       },
//       {
//         subCategory: 'Rings',
//         productStyleMenus: [
//           {
//             name: 'Band rings',
//           },
//           {
//             name: 'Engagement rings',
//             link: '/',
//           },
//           {
//             name: 'Casual rings',
//           },
//         ],
//       },
//     ],
//     link: '',
//   },
//   {
//     id: 4,
//     name: 'Silver',
//     hasSubMenu: true,
//     mainCategory: 'silver',
//     subMenus: [
//       {
//         subCategory: 'Earrings',
//         productStyleMenus: [
//           {
//             name: 'Studs',
//           },
//           {
//             name: 'Hangings',
//           },
//           {
//             name: 'Drops',
//           },
//         ],
//       },
//       {
//         subCategory: 'Necklace',
//         productStyleMenus: [
//           {
//             name: 'Short necklace',
//           },
//           {
//             name: 'Long necklace',
//           },
//         ],
//       },
//       {
//         subCategory: 'Rings',
//         productStyleMenus: [
//           {
//             name: 'Band rings',
//           },
//           {
//             name: 'Engagement rings',
//           },
//           {
//             name: 'Casual rings',
//           },
//         ],
//       },
//     ],
//     link: '',
//   },
//   {
//     id: 5,
//     name: 'Platinum',
//     hasSubMenu: true,
//     mainCategory: 'platinum',
//     subMenus: [
//       {
//         subCategory: 'Earrings',
//         productStyleMenus: [
//           {
//             name: 'Studs',
//           },
//           {
//             name: 'Hangings',
//           },
//           {
//             name: 'Drops',
//           },
//         ],
//       },
//       {
//         subCategory: 'Necklace',
//         productStyleMenus: [
//           {
//             name: 'Short necklace',
//           },
//           {
//             name: 'Long necklace',
//           },
//         ],
//       },
//       {
//         subCategory: 'Rings',
//         productStyleMenus: [
//           {
//             name: 'Band rings',
//           },
//           {
//             name: 'Engagement rings',
//           },
//           {
//             name: 'Casual rings',
//           },
//         ],
//       },
//     ],
//     link: '',
//   },
//   {
//     id: 6,
//     name: 'About',
//     hasSubMenu: false,
//     mainCategory: '',
//     subMenus: [],
//     link: '/about',
//   },
//   {
//     id: 7,
//     name: 'Contact',
//     hasSubMenu: false,
//     mainCategory: '',
//     subMenus: [],
//     link: '/contactus',
//   },
// ]

export const webMenuCopy = [
  {
    id: 2,
    name: 'Gold',
    hasSubMenu: true,
    mainCategory: 'gold',
    subMenus: [
      {
        subCategory: 'thali',
        name: 'Thali',
      },
      {
        subCategory: 'bangle',
        name: 'Bangle',
      },
      {
        subCategory: 'long',
        name: 'Long',
      },
      {
        subCategory: 'dollar',
        name: 'Dollar',
      },
      {
        subCategory: 'necklace',
        name: 'Necklace',
      },
      {
        subCategory: 'bracelet',
        name: 'Bracelet',
      },
      {
        subCategory: 'chain',
        name: 'Chain',
      },
      {
        subCategory: 'mattil',
        name: 'Mattil',
      },
      {
        subCategory: 'drops',
        name: 'Drops',
      },
      {
        subCategory: 'ring',
        name: 'Ring',
      },
    ],
    link: '',
  },
  {
    id: 4,
    name: 'Silver',
    hasSubMenu: true,
    mainCategory: 'silver',
    subMenus: [
      {
        subCategory: 'earrings',
        name: 'Earrings',
      },
      {
        subCategory: 'necklace',
        name: 'Necklace',
      },
      {
        subCategory: 'rings',
        name: 'Rings',
      },
    ],
    link: '',
  },
  {
    id: 6,
    name: 'About',
    hasSubMenu: false,
    mainCategory: '',
    subMenus: [],
    link: '/about',
  },
  {
    id: 7,
    name: 'Contact',
    hasSubMenu: false,
    mainCategory: '',
    subMenus: [],
    link: '/contactus',
  },
]

export const mobileMenu = [
  {
    name: 'Gold',
    isCollapsible: true,
    open: false,
    active: false,
    mainCategory: 'gold',
    menus: ['/empoyees', '/freelancers', '/autouniquecustid'],
    subMenu: [
      {
        subCategory: 'thali',
        name: 'Thali',
        isCollapsible: true,
        open: false,
        active: false,
        menus: ['/empoyees', '/freelancers'],
        // nestedSubMenu: [
        //   {
        //     name: 'Studs',
        //     productStyle: 'studs',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Hangings',
        //     productStyle: 'hangings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Drops',
        //     productStyle: 'drops',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
      {
        subCategory: 'bangle',
        name: 'Bangle',
        isCollapsible: true,
        open: false,
        active: false,
        menus: ['/autouniquecustid', '/customerdetails', '/documentation'],
        // nestedSubMenu: [
        //   {
        //     name: 'Short Necklace',
        //     productStyle: 'short necklace',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Long Necklace',
        //     productStyle: 'long necklace',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
      {
        subCategory: 'long',
        name: 'Long',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
        // nestedSubMenu: [
        //   {
        //     name: 'Band',
        //     productStyle: 'band',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Engagement Rings',
        //     productStyle: 'engagement rings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Casual Rings',
        //     productStyle: 'casual rings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
      {
        subCategory: 'dollar',
        name: 'Dollar',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'necklace',
        name: 'Necklace',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'bracelet',
        name: 'Bracelet',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'chain',
        name: 'Chain',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'mattil',
        name: 'Mattil',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'drops',
        name: 'Drops',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
      {
        subCategory: 'ring',
        name: 'Ring',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
      },
    ],
  },
  {
    name: 'Silver',
    isCollapsible: true,
    open: false,
    active: false,
    mainCategory: 'silver',
    menus: ['/empoyees', '/freelancers', '/autouniquecustid'],
    subMenu: [
      {
        name: 'Earrings',
        subCategory: 'earrings',
        isCollapsible: true,
        open: false,
        active: false,
        menus: ['/empoyees', '/freelancers'],
        // nestedSubMenu: [
        //   {
        //     name: 'Studs',
        //     productStyle: 'studs',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Hangings',
        //     productStyle: 'hangings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Drops',
        //     productStyle: 'drops',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
      {
        name: 'Necklace',
        subCategory: 'necklace',
        isCollapsible: true,
        open: false,
        active: false,
        menus: ['/autouniquecustid', '/customerdetails', '/documentation'],
        // nestedSubMenu: [
        //   {
        //     name: 'Short Necklace',
        //     productStyle: 'short necklace',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Long Necklace',
        //     productStyle: 'long necklace',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
      {
        name: 'Rings',
        subCategory: 'rings',
        isCollapsible: true,
        open: false,
        active: false,
        menus: [
          '/autouniqueponumber',
          '/customerdetails',
          '/deliverypreference',
          '/catalogue',
          '/ordersubmission',
        ],
        // nestedSubMenu: [
        //   {
        //     name: 'Band',
        //     productStyle: 'band',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Engagement Rings',
        //     productStyle: 'engagement rings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        //   {
        //     name: 'Casual Rings',
        //     productStyle: 'casual rings',
        //     isCollapsible: false,
        //     open: false,
        //     active: false,
        //     link: '/',
        //   },
        // ],
      },
    ],
  },
  {
    name: 'About',
    isCollapsible: false,
    open: false,
    active: false,
    link: '/about',
    subMenu: [],
    menus: [],
  },
  {
    name: 'Contact',
    isCollapsible: false,
    open: false,
    active: false,
    link: '/contactus',
    subMenu: [],
    menus: [],
  },
]

// Combining menu
export const Menu = [
  {
    id: 1,
    mainCategory: 'gold',
    isCollapsible: true,
    open: false,
    active: false,
    name: 'gold',
    link: '',
    subMenus: [
      {
        subCategory: 'thali',
        name: 'Thali',
        open: false,
        active: false,
      },
      {
        subCategory: 'bangle',
        name: 'Bangle',
        open: false,
        active: false,
      },
      {
        subCategory: 'long',
        name: 'Long',
        open: false,
        active: false,
      },
      {
        subCategory: 'dollar',
        name: 'Dollar',
        open: false,
        active: false,
      },
      {
        subCategory: 'necklace',
        name: 'Necklace',
        open: false,
        active: false,
      },
      {
        subCategory: 'bracelet',
        name: 'Bracelet',
        open: false,
        active: false,
      },
      {
        subCategory: 'chain',
        name: 'Chain',
        open: false,
        active: false,
      },
      {
        subCategory: 'mattil',
        name: 'Mattil',
      },
      {
        subCategory: 'drops',
        name: 'Drops',
        open: false,
        active: false,
      },
      {
        subCategory: 'ring',
        name: 'Ring',
        open: false,
        active: false,
      },
    ],
  },
  {
    id: 2,
    mainCategory: 'silver',
    isCollapsible: true,
    open: false,
    active: false,
    name: 'Silver',
    link: '',
    subMenus: [
      {
        subCategory: 'dollars',
        name: 'Dollar',
        open: false,
        active: false,
      },
      {
        subCategory: 'thani',
        name: 'Thani',
        open: false,
        active: false,
      },
      {
        subCategory: 'sembu',
        name: 'Sembu',
        open: false,
        active: false,
      },
      {
        subCategory: 'bowl',
        name: 'Bowl',
        open: false,
        active: false,
      },
      {
        subCategory: 'ornament',
        name: 'Ornament',
        open: false,
        active: false,
      },
      {
        subCategory: 'metty',
        name: 'Metty',
        open: false,
        active: false,
      },
      {
        subCategory: 'medal',
        name: 'Medal',
        open: false,
        active: false,
      },
      {
        subCategory: 'plate',
        name: 'Plate',
        open: false,
        active: false,
      },
      {
        subCategory: 'tumbler',
        name: 'Tumbler',
        open: false,
        active: false,
      },
      {
        subCategory: 'deepam',
        name: 'Deepam',
        open: false,
        active: false,
      },
      {
        subCategory: 'kum kuma chimil',
        name: 'Kum Kuma Chimil',
        open: false,
        active: false,
      },
      {
        subCategory: 'golusu',
        name: 'Golusu',
        open: false,
        active: false,
      },
    ],
  },
  {
    id: 3,
    mainCategory: '',
    isCollapsible: false,
    open: false,
    active: false,
    name: 'About',
    link: '/about',
    subMenus: [],
  },
  {
    id: 4,
    mainCategory: '',
    isCollapsible: false,
    open: false,
    active: false,
    name: 'Contact',
    link: '/contactus',
    subMenus: [],
  },
]
